{
  "$ref": "#/definitions/Schema",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "definitions": {
    "ActivityType": {
      "anyOf": [
        {
          "$ref": "#/definitions/IFilter"
        },
        {
          "$ref": "#/definitions/IProject"
        },
        {
          "$ref": "#/definitions/IGroupBy"
        },
        {
          "$ref": "#/definitions/ISort"
        },
        {
          "$ref": "#/definitions/ILimit"
        },
        {
          "$ref": "#/definitions/IMappings"
        }
      ]
    },
    "AggregateType": {
      "anyOf": [
        {
          "$ref": "#/definitions/IAggregate"
        },
        {
          "$ref": "#/definitions/ICount"
        }
      ]
    },
    "Dataset": {
      "items": {},
      "type": "array"
    },
    "DatasourceType": {
      "anyOf": [
        {
          "$ref": "#/definitions/IWUResult"
        },
        {
          "$ref": "#/definitions/ILogicalFile"
        },
        {
          "$ref": "#/definitions/IRoxieService"
        },
        {
          "$ref": "#/definitions/IHipieService"
        },
        {
          "$ref": "#/definitions/IRestService"
        },
        {
          "$ref": "#/definitions/IForm"
        },
        {
          "$ref": "#/definitions/IDatabomb"
        }
      ]
    },
    "FilterCondition": {
      "anyOf": [
        {
          "$ref": "#/definitions/IFilterCondition"
        },
        {
          "$ref": "#/definitions/IFilterStaticCondition"
        }
      ]
    },
    "IAggregate": {
      "additionalProperties": false,
      "properties": {
        "baseCountFieldID": {
          "type": "string"
        },
        "fieldID": {
          "type": "string"
        },
        "inFieldID": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/IAggregateType"
        }
      },
      "required": [
        "fieldID",
        "type",
        "inFieldID"
      ],
      "type": "object"
    },
    "IAggregateType": {
      "enum": [
        "min",
        "max",
        "sum",
        "mean",
        "variance",
        "deviation"
      ],
      "type": "string"
    },
    "ICalculated": {
      "additionalProperties": false,
      "properties": {
        "fieldID": {
          "type": "string"
        },
        "sourceFieldID1": {
          "type": "string"
        },
        "sourceFieldID2": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/ICalculatedType"
        }
      },
      "required": [
        "fieldID",
        "type",
        "sourceFieldID1",
        "sourceFieldID2"
      ],
      "type": "object"
    },
    "ICalculatedType": {
      "enum": [
        "+",
        "-",
        "*",
        "/"
      ],
      "type": "string"
    },
    "ICount": {
      "additionalProperties": false,
      "properties": {
        "fieldID": {
          "type": "string"
        },
        "type": {
          "const": "count",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type"
      ],
      "type": "object"
    },
    "IDatabomb": {
      "additionalProperties": false,
      "properties": {
        "fields": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "format": {
          "$ref": "#/definitions/IDatabombFormat"
        },
        "id": {
          "type": "string"
        },
        "payload": {
          "type": "string"
        },
        "type": {
          "const": "databomb",
          "type": "string"
        }
      },
      "required": [
        "fields",
        "format",
        "id",
        "type"
      ],
      "type": "object"
    },
    "IDatabombFormat": {
      "enum": [
        "csv",
        "tsv",
        "json"
      ],
      "type": "string"
    },
    "IDatabombRef": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "type": "object"
    },
    "IDatasource": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/IDatasourceType"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IDatasourceRef": {
      "anyOf": [
        {
          "$ref": "#/definitions/IDatabombRef"
        },
        {
          "$ref": "#/definitions/IWUResultRef"
        },
        {
          "$ref": "#/definitions/IRoxieServiceRef"
        },
        {
          "$ref": "#/definitions/IHipieSqlRef"
        }
      ]
    },
    "IDatasourceType": {
      "enum": [
        "wuresult",
        "logicalfile",
        "roxie",
        "hipie",
        "rest",
        "form",
        "databomb"
      ],
      "type": "string"
    },
    "IEquals": {
      "additionalProperties": false,
      "properties": {
        "fieldID": {
          "type": "string"
        },
        "sourceFieldID": {
          "type": "string"
        },
        "transformations": {
          "items": {
            "$ref": "#/definitions/MultiTransformationType"
          },
          "type": "array"
        },
        "type": {
          "const": "=",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type",
        "sourceFieldID"
      ],
      "type": "object"
    },
    "IField": {
      "anyOf": [
        {
          "$ref": "#/definitions/IFieldBoolean"
        },
        {
          "$ref": "#/definitions/IFieldNumber"
        },
        {
          "$ref": "#/definitions/IFieldNumber64"
        },
        {
          "$ref": "#/definitions/IFieldString"
        },
        {
          "$ref": "#/definitions/IFieldRange"
        },
        {
          "$ref": "#/definitions/IFieldDataset"
        },
        {
          "$ref": "#/definitions/IFieldSet"
        },
        {
          "$ref": "#/definitions/IFieldObject"
        }
      ]
    },
    "IFieldBoolean": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "type": "boolean"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "boolean",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IFieldDataset": {
      "additionalProperties": false,
      "properties": {
        "children": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "default": {
          "$ref": "#/definitions/Dataset"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "dataset",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id",
        "children"
      ],
      "type": "object"
    },
    "IFieldNumber": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "type": "number"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "number",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IFieldNumber64": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "$ref": "#/definitions/Number64"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "number64",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IFieldObject": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "type": "object"
        },
        "fields": {
          "additionalProperties": {
            "$ref": "#/definitions/IField"
          },
          "type": "object"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "object",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id",
        "fields"
      ],
      "type": "object"
    },
    "IFieldRange": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "$ref": "#/definitions/Range"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "range",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IFieldSet": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "items": {
            "type": [
              "string",
              "number"
            ]
          },
          "type": "array"
        },
        "fieldType": {
          "enum": [
            "string",
            "number"
          ],
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "set",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id",
        "fieldType"
      ],
      "type": "object"
    },
    "IFieldString": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "string",
          "type": "string"
        }
      },
      "required": [
        "type",
        "id"
      ],
      "type": "object"
    },
    "IFieldType": {
      "enum": [
        "boolean",
        "number",
        "number64",
        "string",
        "range",
        "dataset",
        "set",
        "object"
      ],
      "type": "string"
    },
    "IFilter": {
      "additionalProperties": false,
      "properties": {
        "conditions": {
          "items": {
            "$ref": "#/definitions/FilterCondition"
          },
          "type": "array"
        },
        "type": {
          "const": "filter",
          "type": "string"
        }
      },
      "required": [
        "conditions",
        "type"
      ],
      "type": "object"
    },
    "IFilterCondition": {
      "additionalProperties": false,
      "properties": {
        "mappings": {
          "items": {
            "$ref": "#/definitions/IMapping"
          },
          "type": "array"
        },
        "viewID": {
          "type": "string"
        }
      },
      "required": [
        "viewID",
        "mappings"
      ],
      "type": "object"
    },
    "IFilterStaticCondition": {
      "additionalProperties": false,
      "properties": {
        "condition": {
          "$ref": "#/definitions/IMappingConditionType"
        },
        "localFieldID": {
          "type": "string"
        },
        "value": {
          "type": [
            "string",
            "number"
          ]
        }
      },
      "required": [
        "localFieldID",
        "condition",
        "value"
      ],
      "type": "object"
    },
    "IForm": {
      "additionalProperties": false,
      "properties": {
        "fields": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "id": {
          "type": "string"
        },
        "type": {
          "const": "form",
          "type": "string"
        }
      },
      "required": [
        "fields",
        "id",
        "type"
      ],
      "type": "object"
    },
    "IGroupBy": {
      "additionalProperties": false,
      "properties": {
        "aggregates": {
          "items": {
            "$ref": "#/definitions/AggregateType"
          },
          "type": "array"
        },
        "groupByIDs": {
          "items": {
            "type": "string"
          },
          "type": "array"
        },
        "type": {
          "const": "groupby",
          "type": "string"
        }
      },
      "required": [
        "aggregates",
        "groupByIDs",
        "type"
      ],
      "type": "object"
    },
    "IHipieService": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "inputs": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "outputs": {
          "$ref": "#/definitions/OutputDict"
        },
        "queryID": {
          "type": "string"
        },
        "querySet": {
          "type": "string"
        },
        "type": {
          "const": "hipie",
          "type": "string"
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "inputs",
        "outputs",
        "queryID",
        "querySet",
        "type",
        "url"
      ],
      "type": "object"
    },
    "IHipieSqlRef": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "type": "object"
    },
    "ILimit": {
      "additionalProperties": false,
      "properties": {
        "limit": {
          "type": "number"
        },
        "type": {
          "const": "limit",
          "type": "string"
        }
      },
      "required": [
        "limit",
        "type"
      ],
      "type": "object"
    },
    "ILogicalFile": {
      "additionalProperties": false,
      "properties": {
        "fields": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "id": {
          "type": "string"
        },
        "logicalFile": {
          "type": "string"
        },
        "type": {
          "const": "logicalfile",
          "type": "string"
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "fields",
        "id",
        "logicalFile",
        "type",
        "url"
      ],
      "type": "object"
    },
    "IMap": {
      "additionalProperties": false,
      "properties": {
        "default": {},
        "fieldID": {
          "type": "string"
        },
        "mappings": {
          "items": {
            "$ref": "#/definitions/IMapMapping"
          },
          "type": "array"
        },
        "sourceFieldID": {
          "type": "string"
        },
        "type": {
          "const": "map",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type",
        "sourceFieldID",
        "default",
        "mappings"
      ],
      "type": "object"
    },
    "IMapMapping": {
      "additionalProperties": false,
      "properties": {
        "newValue": {},
        "value": {}
      },
      "required": [
        "value",
        "newValue"
      ],
      "type": "object"
    },
    "IMapping": {
      "additionalProperties": false,
      "properties": {
        "condition": {
          "$ref": "#/definitions/IMappingConditionType"
        },
        "localFieldID": {
          "type": "string"
        },
        "nullable": {
          "type": "boolean"
        },
        "remoteFieldID": {
          "type": "string"
        }
      },
      "required": [
        "remoteFieldID",
        "localFieldID",
        "condition",
        "nullable"
      ],
      "type": "object"
    },
    "IMappingConditionType": {
      "enum": [
        "==",
        "!=",
        ">",
        ">=",
        "<",
        "<=",
        "range",
        "in"
      ],
      "type": "string"
    },
    "IMappings": {
      "additionalProperties": false,
      "properties": {
        "transformations": {
          "items": {
            "$ref": "#/definitions/ProjectTransformationType"
          },
          "type": "array"
        },
        "type": {
          "const": "mappings",
          "type": "string"
        }
      },
      "required": [
        "transformations",
        "type"
      ],
      "type": "object"
    },
    "IMulti": {
      "additionalProperties": false,
      "properties": {
        "fieldID": {
          "type": "string"
        },
        "transformations": {
          "items": {
            "$ref": "#/definitions/MultiTransformationType"
          },
          "type": "array"
        },
        "type": {
          "const": "multi",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type",
        "transformations"
      ],
      "type": "object"
    },
    "IOutput": {
      "additionalProperties": false,
      "properties": {
        "fields": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        }
      },
      "required": [
        "fields"
      ],
      "type": "object"
    },
    "IProject": {
      "additionalProperties": false,
      "properties": {
        "transformations": {
          "items": {
            "$ref": "#/definitions/ProjectTransformationType"
          },
          "type": "array"
        },
        "type": {
          "const": "project",
          "type": "string"
        }
      },
      "required": [
        "transformations",
        "type"
      ],
      "type": "object"
    },
    "IProperties": {
      "type": "object"
    },
    "IRequestField": {
      "additionalProperties": false,
      "properties": {
        "localFieldID": {
          "type": "string"
        },
        "remoteFieldID": {
          "type": "string"
        },
        "source": {
          "type": "string"
        },
        "value": {
          "type": "string"
        }
      },
      "required": [
        "localFieldID",
        "source",
        "remoteFieldID",
        "value"
      ],
      "type": "object"
    },
    "IRestService": {
      "additionalProperties": false,
      "properties": {
        "action": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "inputs": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "mode": {
          "enum": [
            "get",
            "post"
          ],
          "type": "string"
        },
        "outputs": {
          "$ref": "#/definitions/OutputDict"
        },
        "type": {
          "const": "rest",
          "type": "string"
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "action",
        "id",
        "inputs",
        "outputs",
        "type",
        "url"
      ],
      "type": "object"
    },
    "IRoxieService": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "inputs": {
          "items": {
            "$ref": "#/definitions/IField"
          },
          "type": "array"
        },
        "outputs": {
          "$ref": "#/definitions/OutputDict"
        },
        "queryID": {
          "type": "string"
        },
        "querySet": {
          "type": "string"
        },
        "type": {
          "const": "roxie",
          "type": "string"
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "inputs",
        "outputs",
        "queryID",
        "querySet",
        "type",
        "url"
      ],
      "type": "object"
    },
    "IRoxieServiceRef": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "output": {
          "type": "string"
        },
        "request": {
          "items": {
            "$ref": "#/definitions/IRequestField"
          },
          "type": "array"
        }
      },
      "required": [
        "id",
        "output",
        "request"
      ],
      "type": "object"
    },
    "IScale": {
      "additionalProperties": false,
      "properties": {
        "factor": {
          "type": "number"
        },
        "fieldID": {
          "type": "string"
        },
        "sourceFieldID": {
          "type": "string"
        },
        "type": {
          "const": "scale",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type",
        "sourceFieldID",
        "factor"
      ],
      "type": "object"
    },
    "ISort": {
      "additionalProperties": false,
      "properties": {
        "conditions": {
          "items": {
            "$ref": "#/definitions/ISortCondition"
          },
          "type": "array"
        },
        "type": {
          "const": "sort",
          "type": "string"
        }
      },
      "required": [
        "conditions",
        "type"
      ],
      "type": "object"
    },
    "ISortCondition": {
      "additionalProperties": false,
      "properties": {
        "descending": {
          "type": "boolean"
        },
        "fieldID": {
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "descending"
      ],
      "type": "object"
    },
    "ITemplate": {
      "additionalProperties": false,
      "properties": {
        "fieldID": {
          "type": "string"
        },
        "template": {
          "type": "string"
        },
        "type": {
          "const": "template",
          "type": "string"
        }
      },
      "required": [
        "fieldID",
        "type",
        "template"
      ],
      "type": "object"
    },
    "IView": {
      "additionalProperties": false,
      "properties": {
        "activities": {
          "items": {
            "$ref": "#/definitions/ActivityType"
          },
          "type": "array"
        },
        "datasource": {
          "$ref": "#/definitions/IDatasourceRef"
        },
        "id": {
          "type": "string"
        },
        "visualization": {
          "$ref": "#/definitions/IVisualization"
        }
      },
      "required": [
        "id",
        "datasource",
        "activities",
        "visualization"
      ],
      "type": "object"
    },
    "IVisualization": {
      "additionalProperties": false,
      "properties": {
        "__class": {
          "type": "string"
        },
        "chartType": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "mappings": {
          "$ref": "#/definitions/IMappings"
        },
        "properties": {
          "$ref": "#/definitions/IWidgetProperties"
        },
        "secondaryDataviewID": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "visibility": {
          "$ref": "#/definitions/VisibilityType"
        }
      },
      "required": [
        "__class",
        "chartType",
        "id",
        "mappings",
        "properties",
        "title",
        "visibility"
      ],
      "type": "object"
    },
    "IWUResult": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "outputs": {
          "$ref": "#/definitions/OutputDict"
        },
        "type": {
          "const": "wuresult",
          "type": "string"
        },
        "url": {
          "type": "string"
        },
        "wuid": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "outputs",
        "type",
        "url",
        "wuid"
      ],
      "type": "object"
    },
    "IWUResultRef": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "output": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "output"
      ],
      "type": "object"
    },
    "IWidgetProperties": {
      "additionalProperties": {
        "anyOf": [
          {
            "type": "string"
          },
          {
            "items": {
              "type": "string"
            },
            "type": "array"
          },
          {
            "type": "number"
          },
          {
            "type": "boolean"
          },
          {
            "not": {}
          },
          {
            "$ref": "#/definitions/IWidgetProperties"
          },
          {
            "items": {
              "$ref": "#/definitions/IWidgetProperties"
            },
            "type": "array"
          }
        ]
      },
      "properties": {
        "__class": {
          "type": "string"
        }
      },
      "required": [
        "__class"
      ],
      "type": "object"
    },
    "MultiTransformationType": {
      "anyOf": [
        {
          "$ref": "#/definitions/IEquals"
        },
        {
          "$ref": "#/definitions/ICalculated"
        },
        {
          "$ref": "#/definitions/IScale"
        },
        {
          "$ref": "#/definitions/ITemplate"
        },
        {
          "$ref": "#/definitions/IMap"
        }
      ]
    },
    "Number64": {
      "type": "string"
    },
    "OutputDict": {
      "additionalProperties": {
        "$ref": "#/definitions/IOutput"
      },
      "type": "object"
    },
    "ProjectTransformationType": {
      "anyOf": [
        {
          "$ref": "#/definitions/MultiTransformationType"
        },
        {
          "$ref": "#/definitions/IMulti"
        }
      ]
    },
    "Range": {
      "items": {
        "type": [
          "number",
          "string"
        ]
      },
      "maxItems": 2,
      "minItems": 2,
      "type": "array"
    },
    "Schema": {
      "additionalProperties": false,
      "properties": {
        "createdBy": {
          "additionalProperties": false,
          "properties": {
            "name": {
              "type": "string"
            },
            "version": {
              "type": "string"
            }
          },
          "required": [
            "name",
            "version"
          ],
          "type": "object"
        },
        "datasources": {
          "items": {
            "$ref": "#/definitions/DatasourceType"
          },
          "type": "array"
        },
        "dataviews": {
          "items": {
            "$ref": "#/definitions/IView"
          },
          "type": "array"
        },
        "defs": {
          "additionalProperties": false,
          "properties": {
            "activityTypes": {
              "additionalProperties": false,
              "properties": {
                "filter": {
                  "$ref": "#/definitions/IFilter"
                },
                "groupby": {
                  "$ref": "#/definitions/IGroupBy"
                },
                "limit": {
                  "$ref": "#/definitions/ILimit"
                },
                "mappings": {
                  "$ref": "#/definitions/IMappings"
                },
                "project": {
                  "$ref": "#/definitions/IProject"
                },
                "sort": {
                  "$ref": "#/definitions/ISort"
                }
              },
              "required": [
                "filter",
                "project",
                "groupby",
                "sort",
                "limit",
                "mappings"
              ],
              "type": "object"
            },
            "aggregateTypes": {
              "additionalProperties": false,
              "properties": {
                "aggregate": {
                  "$ref": "#/definitions/IAggregate"
                },
                "count": {
                  "$ref": "#/definitions/ICount"
                }
              },
              "required": [
                "aggregate",
                "count"
              ],
              "type": "object"
            },
            "datasourceRefTypes": {
              "additionalProperties": false,
              "properties": {
                "roxieServiceRef": {
                  "$ref": "#/definitions/IRoxieServiceRef"
                },
                "wuResultRef": {
                  "$ref": "#/definitions/IWUResultRef"
                }
              },
              "required": [
                "wuResultRef",
                "roxieServiceRef"
              ],
              "type": "object"
            },
            "datasourceTypes": {
              "additionalProperties": false,
              "properties": {
                "databomb": {
                  "$ref": "#/definitions/IDatabomb"
                },
                "datasource": {
                  "$ref": "#/definitions/IDatasource"
                },
                "form": {
                  "$ref": "#/definitions/IForm"
                },
                "hipieService": {
                  "$ref": "#/definitions/IHipieService"
                },
                "logicalFile": {
                  "$ref": "#/definitions/ILogicalFile"
                },
                "roxieService": {
                  "$ref": "#/definitions/IRoxieService"
                },
                "wuresult": {
                  "$ref": "#/definitions/IWUResult"
                }
              },
              "required": [
                "datasource",
                "logicalFile",
                "form",
                "databomb",
                "wuresult",
                "hipieService",
                "roxieService"
              ],
              "type": "object"
            },
            "fieldTypes": {
              "additionalProperties": false,
              "properties": {
                "dataset": {
                  "$ref": "#/definitions/Dataset"
                },
                "field": {
                  "$ref": "#/definitions/IField"
                },
                "fieldBoolean": {
                  "$ref": "#/definitions/IFieldBoolean"
                },
                "fieldDataset": {
                  "$ref": "#/definitions/IFieldDataset"
                },
                "fieldNumber": {
                  "$ref": "#/definitions/IFieldNumber"
                },
                "fieldNumber64": {
                  "$ref": "#/definitions/IFieldNumber64"
                },
                "fieldObject": {
                  "$ref": "#/definitions/IFieldObject"
                },
                "fieldRange": {
                  "$ref": "#/definitions/IFieldRange"
                },
                "fieldSet": {
                  "$ref": "#/definitions/IFieldSet"
                },
                "fieldString": {
                  "$ref": "#/definitions/IFieldString"
                },
                "fieldType": {
                  "$ref": "#/definitions/IFieldType"
                },
                "number64": {
                  "$ref": "#/definitions/Number64"
                },
                "range": {
                  "$ref": "#/definitions/Range"
                }
              },
              "required": [
                "number64",
                "range",
                "dataset",
                "fieldType",
                "fieldBoolean",
                "fieldNumber",
                "fieldNumber64",
                "fieldString",
                "fieldRange",
                "fieldDataset",
                "fieldSet",
                "fieldObject",
                "field"
              ],
              "type": "object"
            },
            "transformationTypes": {
              "additionalProperties": false,
              "properties": {
                "calculated": {
                  "$ref": "#/definitions/ICalculated"
                },
                "equals": {
                  "$ref": "#/definitions/IEquals"
                },
                "map": {
                  "$ref": "#/definitions/IMap"
                },
                "multi": {
                  "$ref": "#/definitions/IMulti"
                },
                "scale": {
                  "$ref": "#/definitions/IScale"
                },
                "template": {
                  "$ref": "#/definitions/ITemplate"
                }
              },
              "required": [
                "equals",
                "calculated",
                "scale",
                "template",
                "map",
                "multi"
              ],
              "type": "object"
            }
          },
          "required": [
            "fieldTypes",
            "datasourceTypes",
            "datasourceRefTypes",
            "activityTypes",
            "aggregateTypes",
            "transformationTypes"
          ],
          "type": "object"
        },
        "hipieProperties": {
          "$ref": "#/definitions/IProperties"
        },
        "properties": {
          "$ref": "#/definitions/IProperties"
        },
        "version": {
          "const": "2.2.1",
          "type": "string"
        }
      },
      "required": [
        "version",
        "createdBy",
        "datasources",
        "dataviews"
      ],
      "type": "object"
    },
    "VisibilityType": {
      "enum": [
        "normal",
        "flyout"
      ],
      "type": "string"
    }
  }
}

